// extracted by mini-css-extract-plugin
export var aboutWithGallery = "AboutWithGallery-module--aboutWithGallery--TdskX";